import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

interface HelpIconProps {
  text: string;
}

const HelpIcon: React.FC<HelpIconProps> = ({ text }) => {
  return (
    <OverlayTrigger
      placement="right"
      overlay={<Tooltip id={`tooltip-help`}>{text}</Tooltip>}
    >
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: "17px",
          border: "1px solid",
          borderColor: "white",
          height: "17px",
          borderRadius: "50%",
          backgroundColor: "transparent",
          color: "white",
          cursor: "pointer",
          fontWeight: "bold",
          fontSize: "14px",
        }}
      >
        ?
      </div>
    </OverlayTrigger>
  );
};

export default HelpIcon;
